export default __webpack_public_path__ + "static/media/151-facade-1.c47307c9.png";